export default __webpack_public_path__ + "static/media/ftmechospiritlp.3b132e1f.png";